import React from 'react';
import styles from '../../styles/match-event-placeholders.module.scss'
import {PlaceholderWrapperComponent} from "../../../../../../core/components/placeholder/placeholder-wrapper";
import classNames from "classnames";
import {MatchEventModulePlaceholderTabs} from "./match-event.module.placeholder.tabs";
import {MatchEventModulePlaceholderStages} from "./match-event.module.placeholder.stages";
import {MATCH_EVENTS} from "../../match-events-widget.consts";

export const MatchEventModulePlaceholder = ({stagesNum = MATCH_EVENTS.PLACEHOLDERS.minimumStages, eventsNum = MATCH_EVENTS.PLACEHOLDERS.minimumRows}) => {
  const stages: Number = stagesNum >= MATCH_EVENTS.PLACEHOLDERS.minimumStages ? stagesNum : MATCH_EVENTS.PLACEHOLDERS.minimumStages;
  const rows: Number = eventsNum >= MATCH_EVENTS.PLACEHOLDERS.minimumRows ? eventsNum : MATCH_EVENTS.PLACEHOLDERS.minimumRows;

  const stageHeight: Number = stages * MATCH_EVENTS.PLACEHOLDERS.stageHeight;
  const rowsHeight: Number = rows * MATCH_EVENTS.PLACEHOLDERS.rowHeight;

  const style = {
    height: stageHeight + rowsHeight + MATCH_EVENTS.PLACEHOLDERS.tabsHeight + 35,
    minHeight: stageHeight + rowsHeight + MATCH_EVENTS.PLACEHOLDERS.tabsHeight + 35
  }

  const placeholderProps = {
    className: classNames(styles.placeholder),
    style: {...style}
  }

  const containerProps = {
    className: classNames(styles.container),
    style: {...style}
  }

  return (
    <div {...placeholderProps}>
      <PlaceholderWrapperComponent {...containerProps}>
        <div {...containerProps}>
          <MatchEventModulePlaceholderTabs/>
          <MatchEventModulePlaceholderStages stagesNum={stagesNum} eventsNum={eventsNum}/>
          <div className={classNames(styles.footer)}/>
        </div>
      </PlaceholderWrapperComponent>
    </div>
  )
};
